import { CheckIcon, CopyIcon } from 'lucide-react'
import { ComponentPropsWithoutRef } from 'react'

import { useCopyToClipboard } from '@/hooks/copy-to-clipboard'
import { cn } from '@/theme/utils'
import {
  UiTooltip,
  UiTooltipContent,
  UiTooltipProvider,
  UiTooltipTrigger,
} from '@/ui/UiTooltip'

export default function CopyWithTooltip({
  value,
  className,
  ...rest
}: { value: string } & ComponentPropsWithoutRef<'button'>) {
  const { copy, isCopied } = useCopyToClipboard()
  return (
    <UiTooltipProvider delayDuration={0}>
      <UiTooltip>
        <button
          {...rest}
          className={cn('cursor-pointer', className)}
          onClick={e => {
            e.stopPropagation()
            e.preventDefault()
            copy(value)
          }}
        >
          <UiTooltipTrigger asChild>
            {isCopied ? (
              <CheckIcon className='text-primary size-4' />
            ) : (
              <CopyIcon className='text-primary size-4' />
            )}
          </UiTooltipTrigger>
        </button>
        <UiTooltipContent className='max-w-75'>
          <p>{isCopied ? 'Copied' : 'Copy'}</p>
        </UiTooltipContent>
      </UiTooltip>
    </UiTooltipProvider>
  )
}
